module.exports = digitalData;